import { useDeviceType } from '@/ueshook/useDeviceType';
import Promote from '@/app/pricing/components/Promote';
import { usePricingModal } from '@/zustand/store';
import { usePathname } from 'next/navigation';
import { posthogUTM, RPostHog } from '@/posthog';
import { useUserInfo } from '@/provider/UserInfoProvider';
import type { PricingModalReportInfo } from '@/zustand/slice/pricingModal';
const { utm } = posthogUTM();

export const PromoteHeader_tailwind_h = 10;
export default function PromoteHeader() {
  const pathname = usePathname();
  const setPricingModalOpen = usePricingModal((s) => s.setPricingModalOpen);
  const deviceType = useDeviceType();

  const { isLoadingUser, userInfo, userIdentity } = useUserInfo();

  return isLoadingUser ? null : (
    <div
      className={`flex w-full cursor-pointer items-center justify-center py-2.5 text-white h-${PromoteHeader_tailwind_h}`}
      style={{
        background: 'linear-gradient(85deg, #FF5D62 45.47%, #FFA575 84.4%)',
      }}
      onClick={() => {
        const reportInfo: PricingModalReportInfo = {
          moduleName: 'promote_header_banner',
          open_way: 'top_header_banner',
          user_id: userInfo?.user_id || 'not_get_user_id',
          email: userInfo?.email || 'not_get_email',
          user_identity: userIdentity,
        };

        switch (userIdentity) {
          case 1:
            reportInfo.user_id = 'no_uer';
            reportInfo.email = 'no_email';
            break;
          case 2:
            reportInfo.email = 'anonymous';
            break;
        }

        setPricingModalOpen(true, {
          reportInfo,
          topHeader: <Promote isModal={true} />,
          cancel_url: `${pathname}`,
          success_redirect: `${pathname}`,
          action: 'operate',
        });

        const today = new Date().toISOString().split('T')[0];
        const lastClickDate = localStorage.getItem('lastClickDate');

        if (lastClickDate !== today) {
          // 点击banner上报，每天清空记录
          RPostHog('user_click_banner', {
            banner_name: 'promote_header_banner',
            ...utm,
          });
          localStorage.setItem('lastClickDate', today);
        }
      }}
    >
      {deviceType === 'mobile'
        ? 'Invite Friends & Save Up to 25% OFF! 🎉'
        : 'Invite Friends & Save Up to 25% OFF – Plus Free Credits! 🎉'}
    </div>
  );
}
